/* eslint-disable max-len */
/* eslint-disable react/style-prop-object */
import React, { FC, useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import { Box, CardMedia, Container, ImageList, ImageListItem } from "@mui/material";
import classes from "./style";
import Articles from "./articles";
import { useParams } from "react-router-dom";
import { DestinationBlog } from "models/Destination";
import destinationBlogService from "services/destinationBlogService";
import { getImageUrl } from "utils/imageUtils";
import ImagesCarousel from "components/carousel/Carousel";

const Article: FC<{}> = () => {
  const [blog, setBlog] = useState<DestinationBlog>();

  const { id } = useParams();
  const [selectedImage, setSelectedImage] = React.useState<any>(null);

  useEffect(() => {
    if (id) { 
      load(Number(id));
      window.scrollTo(0, 0);
    }
  }, [id]);
  
  const load = async(blogId: number) => {
    setBlog(await destinationBlogService.get(blogId));
  }

  const getImage = (blog: DestinationBlog) : string => {
    const imgs = blog.destinationBlogPictures;
    const main = imgs.find(i => i.mainPicture);
    if (main) {
      return getImageUrl(main.url);
    }

    return imgs.length > 0 ? getImageUrl(imgs[0].url) : null;
  }

  return <>
    <Container
      sx={[
        classes.root,
        classes.calendrier,
        classes.destinationBloc,
        classes.article,
      ]}
    > { blog && <>
      <Typography variant="h1">{blog.title}</Typography>
      <Box sx={classes.destinationContent}>
        <CardMedia
          title={blog.title}
          src={getImage(blog)}
          component="img"
          height="300"
          sx={{ width: "100%", height: "300px" }}
        />
        <Typography variant="body1">{blog.description}</Typography>
        <Typography variant="body1">
          <div dangerouslySetInnerHTML={{ __html: blog.content }} />
        </Typography>

        <ImageList variant="quilted" cols={2}>

          {
            blog.destinationBlogPictures.length == 0 ? '' : (
              blog.destinationBlogPictures.length == 1 ?
              <img src={getImageUrl(blog.destinationBlogPictures[0].url)} width="100%" height="100%" 
                loading="lazy" onClick={() => setSelectedImage({title: blog.destinationBlogPictures[0].id})}/>
                : (
                  blog.destinationBlogPictures.length == 2 ?
                  [0, 1].map((item, i) => (
                    <ImageListItem key={item.toString()} cols={2} rows={1}>
                      <img src={getImageUrl(blog.destinationBlogPictures[item].url)} width="100%" height="100%" 
                        loading="lazy" onClick={() => setSelectedImage({title: blog.destinationBlogPictures[item].id})}/>
                    </ImageListItem>))
                   :
                   [0, 1, 2].map((item, i) => (
                    <ImageListItem key={item.toString()} cols={i == 0 ? 2 : 1} rows={2}>
                    <img src={getImageUrl(blog.destinationBlogPictures[i].url)} width="100%" height="100%" 
                        loading="lazy" onClick={() => setSelectedImage({title: blog.destinationBlogPictures[item].id})}/>
                    </ImageListItem>))
                  )
                )
          }
        </ImageList>
      </Box>

      <Articles />

      </>
      }
    </Container>
      {
        blog?.destinationBlogPictures.length > 0 ? 
        <ImagesCarousel
          open={selectedImage ? true : false}
          images={blog.destinationBlogPictures.map((i) => {
            return {
              img: getImageUrl(i.url),
              title: i.id,
            };
          })}
          selectedImage={selectedImage}
          handleClose={() => {
            setSelectedImage(null);
          }}
      /> : ''
    }
    </>
  ;
};

export default Article;
